import EntityModel from '@/common/models/entity-model';

export default class OrderSummaryModel extends EntityModel {
    hydrate({
        collectedAmount = null,
        currency = null,
        invoiceCount = null,
        invoicedAmount = null,
    } = {}) {
        this.collectedAmount = Number(collectedAmount || 0);
        this.currency = currency;
        this.invoiceCount = Number(invoiceCount || 0);
        this.invoicedAmount = Number(invoicedAmount || 0);
    }
}
